module.exports = __webpack_public_path__ + "img/aside-right-bg.82a736bd.png";